import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { urlFor, client } from '../../client';

const About = () => {
  const [abouts, setAbouts] = useState([]);
  const [certies, setCerties] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';
    const certiesQuery = '*[_type == "certies"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
      console.log(data);
    });

    client.fetch(certiesQuery).then((data) => {
      setCerties(data);
      console.log(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">A little <span>progress</span> each day adds up to big <span>results.</span></h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.Title + index}
          > 
            <img src={urlFor(about.Imageurl)} alt={about.Title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.Title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.Description}</p>
          </motion.div>
        ))}
      </div>
      <br />


      <div className='edu'>
        <h3>Education</h3><br />

        <div className='edu__detail'>
          <span>2018 - 2021</span>
          <div>
            <p>Gujarat Technological University</p>
            <p>Goverment polytechnic of Ahmedabad</p>
            <p>Diploma - Computer engineering</p>
            <p>Passout CGPA - 9.33</p>
          </div>
        </div>
        
        <div className='edu__detail'>
          <span>2021 - 2024</span>
          <div>
            <p>Gujarat Technological University</p>
            <p>Goverment engineering college, Gandhinagar sector-28</p>
            <p>BE - Computer engineering</p>
            <p>Currently parsuing</p>
          </div>
        </div>
      </div>

      <br />
      <h3>Certifications</h3>
      <div className="certi">
        {certies.map((certi, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.3 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="certi-item"
          >
            <img src={urlFor(certi.Imageurl)} alt={certi.Imageurl} />
          </motion.div>
        ))} 
      </div>
      
      <br />
      <h3>I want to say</h3>
      <p style={{width:"70%", marginTop:"2rem", padding:"2rem", border:"2px dashed green", borderRadius:"20px"}}>Fullstack developer with ability to learn and collaborate in rapidly changing environments and compositions. Eager to tackle web development/design challenges to achieve lasting impacts on user experience.</p>

    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);